<ng-container *ngIf="!renaming">
  <span style="margin-right: 5px">{{ name }}</span>
  <button
    *ngIf="canRename"
    (click)="startRenaming()"
    pButton
    type="button"
    icon="fa fa-edit"
  ></button>
</ng-container>
<ng-container *ngIf="renaming">
  <input
    pInputText
    #headerField
    [ngModel]="draftName"
    (ngModelChange)="updateName($event)"
    (blur)="finishRenaming()"
    (keydown.enter)="finishRenaming()"
  />
  {{ headerField.focus() }}
</ng-container>
